module.exports = __webpack_public_path__ + "static/wpack/extracted/icon--space-cocoblocksd48043123f7bea5267786c5dbdb54783.svg";